import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { id: number; delCode: string; description: string; displayOnClientSite: boolean; clientInfoMsg: string | null; deleted: boolean; }
const schema = z.object({
  delCode: z.string().min(1).max(20),
  description: z.string().min(1).max(100),
  displayOnClientSite: z.boolean(),
  clientInfoMsg: z.string().max(500).nullable().optional(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function DeliveryMethodsPage() {
  return <LookupListPage<Row, Form>
    title="Delivery methods"
    apiPath="/api/lookups/delivery-methods"
    schema={schema}
    rowKey={(r) => r.id}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.delCode },
      { id: "desc", header: "Description", accessor: (r) => r.description },
      { id: "site", header: "Client-site", accessor: (r) => r.displayOnClientSite ? "Yes" : "—" },
      { id: "msg",  header: "Client info msg", accessor: (r) => r.clientInfoMsg ?? "—" },
    ]}
    toFormValues={(r) => ({ delCode: r.delCode, description: r.description, displayOnClientSite: r.displayOnClientSite, clientInfoMsg: r.clientInfoMsg ?? "", deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ delCode: "", description: "", displayOnClientSite: false, clientInfoMsg: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("delCode")} /></div>
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <label className="flex items-center gap-2"><input type="checkbox" {...f.register("displayOnClientSite")} /> Display on client site</label>
        <div><Label htmlFor="m">Client info message</Label><Input id="m" {...f.register("clientInfoMsg")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
